// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtl .userListBox {
    left: 0;
    right: auto;
}

.rtl .headerSubLink {
    text-align: right;
}

.rtl .dropdown-item {
    text-align: right;
}

.rtl .searchInputHeader {
    right: auto;
    left: 0;
}

.rtl .homeNavLink {
    text-align: right;
}

.rtl .homeNavDropDown {
    padding: 0;
}

.rtl .float-end {
    float: left !important;
}

.rtl .priceLabel {
    border-top-left-radius: 2px;
    border-top-right-radius: 5px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 2px;
    right: 0;
    left: auto;
}

.rtl .homePageSwiper .swiper-slide-active .homeSwiperContainer {
    right: 25px;
}

.rtl .beforeCircle::after {
    display: none;

}

.rtl .beforeCircle::before {
    width: 5px;
    height: 5px;
    background-color: #fff;
    border-radius: 50%;
    content: "";
    position: absolute;
    top: 0px;
    bottom: 0;
    margin: auto;
    right: -16px;
}

.rtl .beforeCircle:first-child::before {
    display: none;
}

.rtl .me-4 {
    margin-left: 1.5rem !important;
    margin-right: 0px !important;
}

.rtl .playerPrev,
.rtl .navigationNext,
.rtl .navigationPrev,
.rtl .playButtonMain.triangle,
.rtl .buttonList,
.rtl .audioBannerPlay,
.rtl .musicPlayButton,
.rtl .arrowIconModal {
    transform: rotate(180deg) !important;
}

.rtl .playerNext {
    transform: rotate(0deg) !important;
}

.rtl .me-5 {
    margin-left: 3rem !important;
    margin-right: 0px !important;
}

.rtl .shareContainer:hover .shareBox {
    right: 0;
    left: auto;
}

.rtl .shareBox {
    right: -10000%;
    left: auto;
    transition: right 0.5s ease-in-out;
}

.rtl .bannerPlayBtn {
    justify-content: start !important;
}

.rtl .volumnButtonImage {
    right: 15px;
    left: auto;
}

.rtl .me-2 {
    margin-right: 0rem !important;
    margin-left: 0.5rem !important;
}

.rtl .signInMenu .eyeButton {
    left: 4px;
    right: auto;
}

.rtl .flickNexsDateShow {
    right: 0;
    left: auto;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 7px;
}

.rtl .flickNexsDateShow::before {
    right: 0;
    clip-path: polygon(100% 0, 0 0, 100% 100%);
}

.rtl .flicknexsDayMaker .flickNexsDateShow::after {
    right: 0;
}

.rtl .timeValues {
    left: auto;
    right: -20px;
}

.rtl .flickNexs24Hours:nth-child(2) .timeValues {
    top: 4px;
    right: 0px;
    direction: rtl;
}

.rtl .flex-reverse {
    flex-direction: row-reverse;
}


.rtl .account-label {
    text-align: right;
}


.rtl .faqSearchThemeTwo {
    left: 0px;
    right: 15px;
}

.rtl .themeTwoFaq .accordion-button::after {
    margin-right: auto;
    margin-left: unset;
}

.rtl .ps-3 {
    padding-right: 1rem !important;
}

.rtl .pe-5 {
    padding-left: 3rem !important;
}

.rtl .closeBtnModal {
    left: 18px;
    right: auto;
}

.rtl .ps-5 {
    padding-right: 3rem !important;
    padding-left: 0px !important;
}

.rtl .searchPageIcon {
    right: 16px;
    left: auto;
}

.rtl .placeholderText {
    right: 19%;
    left: auto;
}

@media screen and (min-width: 1200px) {
    .rtl .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {
        right: auto;
        left: 24px;
    }
}

@media screen and (max-width: 1200px) {
    .rtl .homeNavbarMobileFixed.active {
        right: 0;
        left: auto;
    }

    .rtl .homeNavbarMobileFixed {
        right: -100%;
        left: auto;
        transition: right 0.4s ease-out;
    }

    .rtl .homeNavSlide {
        padding: 0;
    }
}

@media screen and (min-width: 1400px) {
    .rtl .viewAllCardTwo:nth-child(7n-6):hover .hoverCardContainer {
        left: auto;
        right: 45px;
    }

    .rtl .viewAllCardTwo:nth-child(7n+0):hover .hoverCardContainer {
        right: auto;
        left: 45px;
    }

}

/* 
.rtl .gridCategoryArrowImage {
    -webkit-box-reflect: right;
}

.rtl .gridCategoryItems:hover .gridCategoryArrowImage {
    -webkit-box-reflect: right;
} */`, "",{"version":3,"sources":["webpack://./src/Styles/rtl-support.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,+BAA+B;IAC/B,+BAA+B;IAC/B,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;;;;;;;;IAQI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,QAAQ;IACR,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,iBAAiB;AACrB;;;AAGA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,UAAU;IACd;AACJ;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,+BAA+B;IACnC;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,WAAW;IACf;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;AAEJ;;AAEA;;;;;;;GAOG","sourcesContent":[".rtl .userListBox {\n    left: 0;\n    right: auto;\n}\n\n.rtl .headerSubLink {\n    text-align: right;\n}\n\n.rtl .dropdown-item {\n    text-align: right;\n}\n\n.rtl .searchInputHeader {\n    right: auto;\n    left: 0;\n}\n\n.rtl .homeNavLink {\n    text-align: right;\n}\n\n.rtl .homeNavDropDown {\n    padding: 0;\n}\n\n.rtl .float-end {\n    float: left !important;\n}\n\n.rtl .priceLabel {\n    border-top-left-radius: 2px;\n    border-top-right-radius: 5px;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 2px;\n    right: 0;\n    left: auto;\n}\n\n.rtl .homePageSwiper .swiper-slide-active .homeSwiperContainer {\n    right: 25px;\n}\n\n.rtl .beforeCircle::after {\n    display: none;\n\n}\n\n.rtl .beforeCircle::before {\n    width: 5px;\n    height: 5px;\n    background-color: #fff;\n    border-radius: 50%;\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    bottom: 0;\n    margin: auto;\n    right: -16px;\n}\n\n.rtl .beforeCircle:first-child::before {\n    display: none;\n}\n\n.rtl .me-4 {\n    margin-left: 1.5rem !important;\n    margin-right: 0px !important;\n}\n\n.rtl .playerPrev,\n.rtl .navigationNext,\n.rtl .navigationPrev,\n.rtl .playButtonMain.triangle,\n.rtl .buttonList,\n.rtl .audioBannerPlay,\n.rtl .musicPlayButton,\n.rtl .arrowIconModal {\n    transform: rotate(180deg) !important;\n}\n\n.rtl .playerNext {\n    transform: rotate(0deg) !important;\n}\n\n.rtl .me-5 {\n    margin-left: 3rem !important;\n    margin-right: 0px !important;\n}\n\n.rtl .shareContainer:hover .shareBox {\n    right: 0;\n    left: auto;\n}\n\n.rtl .shareBox {\n    right: -10000%;\n    left: auto;\n    transition: right 0.5s ease-in-out;\n}\n\n.rtl .bannerPlayBtn {\n    justify-content: start !important;\n}\n\n.rtl .volumnButtonImage {\n    right: 15px;\n    left: auto;\n}\n\n.rtl .me-2 {\n    margin-right: 0rem !important;\n    margin-left: 0.5rem !important;\n}\n\n.rtl .signInMenu .eyeButton {\n    left: 4px;\n    right: auto;\n}\n\n.rtl .flickNexsDateShow {\n    right: 0;\n    left: auto;\n    border-bottom-right-radius: 0px;\n    border-bottom-left-radius: 7px;\n}\n\n.rtl .flickNexsDateShow::before {\n    right: 0;\n    clip-path: polygon(100% 0, 0 0, 100% 100%);\n}\n\n.rtl .flicknexsDayMaker .flickNexsDateShow::after {\n    right: 0;\n}\n\n.rtl .timeValues {\n    left: auto;\n    right: -20px;\n}\n\n.rtl .flickNexs24Hours:nth-child(2) .timeValues {\n    top: 4px;\n    right: 0px;\n    direction: rtl;\n}\n\n.rtl .flex-reverse {\n    flex-direction: row-reverse;\n}\n\n\n.rtl .account-label {\n    text-align: right;\n}\n\n\n.rtl .faqSearchThemeTwo {\n    left: 0px;\n    right: 15px;\n}\n\n.rtl .themeTwoFaq .accordion-button::after {\n    margin-right: auto;\n    margin-left: unset;\n}\n\n.rtl .ps-3 {\n    padding-right: 1rem !important;\n}\n\n.rtl .pe-5 {\n    padding-left: 3rem !important;\n}\n\n.rtl .closeBtnModal {\n    left: 18px;\n    right: auto;\n}\n\n.rtl .ps-5 {\n    padding-right: 3rem !important;\n    padding-left: 0px !important;\n}\n\n.rtl .searchPageIcon {\n    right: 16px;\n    left: auto;\n}\n\n.rtl .placeholderText {\n    right: 19%;\n    left: auto;\n}\n\n@media screen and (min-width: 1200px) {\n    .rtl .homePageSwiper .swiper-slide-next+.swiper-slide+.swiper-slide+.swiper-slide+.swiper-slide .homeSwiperContainer {\n        right: auto;\n        left: 24px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .rtl .homeNavbarMobileFixed.active {\n        right: 0;\n        left: auto;\n    }\n\n    .rtl .homeNavbarMobileFixed {\n        right: -100%;\n        left: auto;\n        transition: right 0.4s ease-out;\n    }\n\n    .rtl .homeNavSlide {\n        padding: 0;\n    }\n}\n\n@media screen and (min-width: 1400px) {\n    .rtl .viewAllCardTwo:nth-child(7n-6):hover .hoverCardContainer {\n        left: auto;\n        right: 45px;\n    }\n\n    .rtl .viewAllCardTwo:nth-child(7n+0):hover .hoverCardContainer {\n        right: auto;\n        left: 45px;\n    }\n\n}\n\n/* \n.rtl .gridCategoryArrowImage {\n    -webkit-box-reflect: right;\n}\n\n.rtl .gridCategoryItems:hover .gridCategoryArrowImage {\n    -webkit-box-reflect: right;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
